/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageViewer/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import FullScreenButton from 'DesignSystem/FullScreenButton/index'
import ImageSeriesDate from './ImageSeriesDate/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PatientAge from './PatientAge/index'
import PatientImages from './PatientImages/index'
import PatientName from './PatientName/index'
import React from 'react'
import ToggleToolbarAction from './ToggleToolbarAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageViewer({
  children,
  viewPath = "/DesignSystem/ImageViewer",
  onClose
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 id="imageviewer"
 width="calc(100vw - 30px)"
 height="calc(100vh - 30px)"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<PatientImages
{...childProps}
  viewPath={`${viewPath}/PatientImages`}
/>
<div
  data-testid="ImageViewer.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZrbeRi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ImageViewer.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<PatientAge
  viewPath={`${viewPath}/PatientAge`}
/>
<ImageSeriesDate
  viewPath={`${viewPath}/ImageSeriesDate`}
/>
</div>
<div
  data-testid="ImageViewer.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="💡 Hold space key to move the image"
 marginRight={dtSpaceL}
/>
<ToggleToolbarAction
  viewPath={`${viewPath}/ToggleToolbarAction`}
/>
<FullScreenButton
  viewPath={`${viewPath}/FullScreenButton`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
 onClose={onClose}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}